module.exports = __webpack_public_path__ + "img/leadboard-active.b21994a1.svg";